import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gray-50 border-t py-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <h3 className="font-bold text-xl mb-4 bg-gradient-to-r from-brand-blue to-brand-purple bg-clip-text text-transparent">SEO Link Market</h3>
            <p className="text-gray-600 mb-4">
              The trusted marketplace for SEO professionals to buy and sell high-quality backlinks.
            </p>
          </div>
          
          <div>
            <h4 className="font-semibold text-gray-900 mb-4">For Buyers</h4>
            <ul className="space-y-2">
              <li><Link to="/buyer-requests" className="text-gray-600 hover:text-brand-blue">Post Buyer Request</Link></li>
              <li><Link to="/sellers" className="text-gray-600 hover:text-brand-blue">Browse Sellers</Link></li>
              <li><Link to="/marketplace" className="text-gray-600 hover:text-brand-blue">Find Link Offers</Link></li>
              <li><Link to="/reviews" className="text-gray-600 hover:text-brand-blue">Customer Reviews</Link></li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-semibold text-gray-900 mb-4">For Sellers</h4>
            <ul className="space-y-2">
              <li><Link to="/signup" className="text-gray-600 hover:text-brand-blue">Become a Seller</Link></li>
              <li><Link to="/create-offer" className="text-gray-600 hover:text-brand-blue">Create Offer</Link></li>
              <li><Link to="/seller-dashboard" className="text-gray-600 hover:text-brand-blue">Seller Dashboard</Link></li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-semibold text-gray-900 mb-4">Resources</h4>
            <ul className="space-y-2">
              <li><Link to="/pricing" className="text-gray-600 hover:text-brand-blue">Pricing</Link></li>
              <li><Link to="/" className="text-gray-600 hover:text-brand-blue">How it Works</Link></li>
              <li><Link to="/" className="text-gray-600 hover:text-brand-blue">FAQ</Link></li>
              <li><Link to="/" className="text-gray-600 hover:text-brand-blue">Contact Us</Link></li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-200 mt-10 pt-6">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-500 text-sm">&copy; {new Date().getFullYear()} SEO Link Market. All rights reserved.</p>
            <div className="flex space-x-6 mt-4 md:mt-0">
              <Link to="/" className="text-gray-500 hover:text-gray-700 text-sm">Terms of Service</Link>
              <Link to="/" className="text-gray-500 hover:text-gray-700 text-sm">Privacy Policy</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
